<template>
    <nav v-if="currentUser.role == 'player'" class="position-fixed border-top d-block d-lg-none w-100 bg-white" style="bottom: 0; left: 0; z-index: 2000;">
        <div class="d-flex justify-content-around">
            <a class="d-flex flex-column justify-content-center align-items-center py-3 text-xs" style="flex: 1 1;" href="/">
                <span class="material-symbols-outlined d-block">home</span>
                <span class="d-block">Accueil</span>
            </a>
            <a class="d-flex flex-column justify-content-center align-items-center py-3 text-xs" style="flex: 1 1;" href="/search">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                    fill="#505050">
                    <path
                        d="M640-560v-126 126ZM174-132q-20 8-37-4.5T120-170v-560q0-13 7.5-23t20.5-15l212-72 240 84 186-72q20-8 37 4.5t17 33.5v337q-15-23-35.5-42T760-528v-204l-120 46v126q-21 0-41 3.5T560-546v-140l-160-56v523l-226 87Zm26-96 120-46v-468l-120 40v474Zm496.5-32q22.5-20 23.5-60 1-34-22.5-57T640-400q-34 0-57 23t-23 57q0 34 23 57t57 23q34 0 56.5-20ZM640-160q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 23-5.5 43.5T778-238l102 102-56 56-102-102q-18 11-38.5 16.5T640-160ZM320-742v468-468Z" />
                </svg>
                <span class="d-block">Réserver</span>
            </a>
            <a class="d-flex flex-column justify-content-center align-items-center py-3 text-xs" style="flex: 1 1;" href="/my/matches">
                <i class="material-symbols-outlined">sports_soccer</i>
                <span class="d-block">Matchs</span>
            </a>
        </div>
    </nav>
</template>
<script>
export default {
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
    }
}
</script>